export default {"src":"/_next/static/media/profileDefaultYellow.3b97d18d.svg","height":80,"width":80};